import React, { useEffect } from "react";
import { Outlet, Route, Routes, Navigate, useNavigate } from "react-router-dom";
import Header from "../../views/layout/Header";
import Sidebar from "../../views/layout/Sidebar";
import ProfileInformation from "../../views/pages/ProfileInformationPage/profileInformation";

import AddNotification from "../../views/pages/Notifications/AddNotification";
import NotificationList from "../../views/pages/Notifications/NotificationList";
import Category from "../../views/pages/Category/category";
import AddCategory from "../../views/pages/Category/addCategory";
import Locations from "../../views/pages/Locations/Locations";
import AddLocations from "../../views/pages/Locations/AddLocations";
import Offers from "../../views/pages/Offers/Offers";
import AddOffers from "../../views/pages/Offers/AddOffers";
import Support from "../../views/pages/Support/Support";
import AddSupport from "../../views/pages/Support/AddSuppot";
import CardsList from "../../views/pages/Cards/CardsList";
import Benefits from "../../views/pages/Benefits/Benefits";
import AddBenefits from "../../views/pages/Benefits/AddBenefits";
// import RewardPoints from '../../views/pages/RewardPoints/RewardsPoints'
import ActivateCard from "../../views/pages/Cards/ActivateCard";
import News from "../../views/pages/News/News";
import Addnews from "../../views/pages/News/AddNews";
import ChargerPoints from "../../views/pages/Charger Points/ChargerPoints";
import Users from "../../views/pages/Users/users";
import AddUser from "../../views/pages/Users/AddUser";
import ChargingHistory from "../../views/pages/ChargingHistory/ChargingHistory";
import Updatecps from "../../views/pages/Charger Points/Updatecps";
import Requestedcards from "../../views/pages/CardRequests/CardRequests";
import AddCharging from "../../views/pages/Charging/AddCharging";
import GenerateInvoice from "../../views/pages/GenerateInvoice/GenerateInvoice";
import FAQ from "../../views/pages/FAQS/FAQs";
import AddFaqs from "../../views/pages/FAQS/AddFaqs";

const AppContainer = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
    }
  }, []);

  const routingObjects = [
    {
      id: 1,
      path: "profileInfo",
      element: <ProfileInformation />,
    },

    {
      id: 2,
      path: "Notifications",
      element: <NotificationList />,
    },
    {
      id: 3,
      path: "addNotifications",
      element: <AddNotification />,
    },
    {
      id: 4,
      path: "category",
      element: <Category />,
    },
    {
      id: 5,
      path: "addCategory/:id?",
      element: <AddCategory />,
    },
    {
      id: 6,
      path: "locations",
      element: <Locations />,
    },
    {
      id: 7,
      path: "AddLocations/:id?",
      element: <AddLocations />,
    },
    {
      id: 8,
      path: "offers",
      element: <Offers />,
    },
    {
      id: 9,
      path: "addOffers/:id?",
      element: <AddOffers />,
    },
    {
      id: 10,
      path: "support",
      element: <Support />,
    },
    {
      id: 11,
      path: "addSupport/:id?",
      element: <AddSupport />,
    },
    {
      id: 12,
      path: "cards/:id?",
      element: <CardsList />,
    },
    {
      id: 13,
      path: "addCards",
      element: <ActivateCard />,
    },
    {
      id: 14,
      path: "benefits",
      element: <Benefits />,
    },
    {
      id: 15,
      path: "addbenefits/:id?",
      element: <AddBenefits />,
    },
    {
      id: 16,
      path: "news",
      element: <News />,
    },
    {
      id: 17,
      path: "addnews/:id?",
      element: <Addnews />,
    },
    {
      id: 18,
      path: "ChargingPoints",
      element: <ChargerPoints />,
    },
    {
      id: 19,
      path: "ChargingPoints/:id?",
      element: <Updatecps />,
    },
    {
      id: 20,
      path: "Users",
      element: <Users />,
    },
    {
      id: 21,
      path: "addUser/:id?",
      element: <AddUser />,
    },
    {
      id: 22,
      path: "ChargingHistory/:id?",
      element: <ChargingHistory />,
    },
    {
      id: 23,
      path: "requestedcards",
      element: <Requestedcards />,
    },
    {
      id: 24,
      path: "addCharging",
      element: <AddCharging />,
    },
    {
      id: 25,
      path: "generateInvoice",
      element: <GenerateInvoice />,
    },
    {
      id: 26,
      path: "faqs",
      element: <FAQ />,
    },
    {
      id: 27,
      path: "addFaqs/:id?",
      element: <AddFaqs />,
    },
    // {
    //   id:16,
    //   path: 'rewardpoints',
    //   element: <RewardPoints />
    // },
  ];

  const SidebarLayout = () => (
    <>
      <Header />
      <Sidebar />
      <Outlet />
    </>
  );
  const mobileResponsive = (event) => {
    const excludedHeader = document.querySelector(".header");
    const excludedSidebar = document.querySelector(".sidebar");

    if (
      !excludedHeader.contains(event.target) &&
      !excludedSidebar.contains(event.target)
    ) {
      document.body.classList.remove("slide-nav");
    }
  };

  return (
    <>
      <div className="main-wrapper" onClick={mobileResponsive}>
        <Routes>
          <Route path={"/*"} element={<SidebarLayout />}>
            {routingObjects.map((item) => (
              <Route key={item.id} path={item.path} element={item.element} />
            ))}
          </Route>
          <Route path={"/*"} element={<SidebarLayout />}>
            <Route path="*" element={<Navigate to="/" />} />
          </Route>
        </Routes>
        {/* <SeachWindowPopup /> */}
      </div>
    </>
  );
};

export default AppContainer;
